import { Navigate, Outlet } from 'react-router-dom'

interface Props {
  children?: any
}

const UnprotectedRoutes = ({ children }: Props) => {
  const auth = localStorage.getItem('auth')

  return !auth ? children || <Outlet /> : <Navigate to={'/'} />
}

export default UnprotectedRoutes
